import { Component, ChangeDetectionStrategy } from '@angular/core';

import { IconComponent, Modal } from '@softline/ui-core';
import { Bewe } from '../../types/bewegung';

export type TeillieferungResponse = 'reklemation'| 'confirmation';

@Component({
  selector: 'soft-teillieferung-dialog',
  imports: [IconComponent],
  templateUrl: './teillieferung-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './teillieferung-dialog.component.css' })
export class TeillieferungDialogComponent
  implements Modal<TeillieferungResponse>
{
  close!: (result: TeillieferungResponse) => void;

  registerCloseHandler(handler: (result: TeillieferungResponse) => void): void {
    this.close = handler;
  }
}
